// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_95-3";
export var contentContainer = "_95-0";
export var editorContainer = "_95-1";
export var quillInputForm = "_95-2";
export var zoneDivider = "_95-4";